import React, { ReactElement } from 'react'
import { ArtData } from '@/database/art'
import Button from '@/components/Button'
import { crazyAmount, priceText, transferFeeText } from '@/utils/formatting'
import Box from '@/components/boxes/Box'
import LoadImageButtonOnDemand from '@/components/LoadImageButtonOnDemand'
import ClaimsTooltip from '@/components/tooltips/VotesTooltip'
import VotesTooltip from '@/components/tooltips/VotesTooltip'

const acceptOfferButtonText = (highestBid: string, highestOffer: string) => {
    const highest = parseFloat(highestBid) > parseFloat(highestOffer) ? highestBid : highestOffer
    const highestString = 'Accept For ' + highest
    return highest && highest !== '-' ? highestString : 'Accept offer'
}

const MyMarketCard = ({
    artData,
    openModalMyMarketCardDetails,
}: {
    artData: ArtData
    openModalMyMarketCardDetails: (artData: ArtData) => void
}): ReactElement => {
    return (
        <div className={'header-container center'}>
            <div key={artData.art.id} className={'artwork-box'}>
                <ClaimsTooltip artData={artData} />
                <div className={'header-container'}>
                    <Box caption={'NFT'} text={'#' + (artData.tokenId ? artData.tokenId : artData.art.id)} />
                    <Box caption={'Title'} text={artData.art.title} />
                </div>
                <div className={'header-container'}>
                    <Box
                        caption={'Description'}
                        styleCaption={'small gray'}
                        styleText={'small white'}
                        text={artData.art.prompt}
                    />
                </div>
                {artData.highestOffer && (
                    <div className="p-copy">
                        <div className={'nav__balance menu-wrapper-column border margin-box bottom'}>
                            <span className={'nav__voted-amount'}>
                                {crazyAmount(artData.highestOffer, `white`)}
                                <span className={'gradient-text bold'}>Highest Offer</span>
                            </span>
                        </div>
                    </div>
                )}
                <LoadImageButtonOnDemand artData={artData} onClick={() => openModalMyMarketCardDetails(artData)} />
                <div className={'header-container'}>
                    <Box caption={'Sale Price'} text={priceText(artData)} triggerAnimation={false} />
                    <Box
                        caption={'Transfer Fee'}
                        text={transferFeeText(artData)}
                        textValue={artData?.art.transferFee}
                        triggerAnimation={false}
                    />
                </div>
                <div className={'header-container'}>
                    <div id={'votes' + artData.tokenId} className="p-copy">
                        <Box caption="Claim Power" text={artData.claimPower.toFixed(2)} />
                    </div>
                    <VotesTooltip artData={artData} />
                    <div id={'claims-made' + artData.tokenId} className="p-copy">
                        <Box caption={'Claims Made'} text={artData.totalClaims.toFixed(2)} />
                    </div>
                    <div id={'claims-received' + artData.tokenId} className="p-copy">
                        <Box caption={'Claims Received'} text={artData.totalClaimed.toFixed(2)} />
                    </div>
                    <ClaimsTooltip artData={artData} />
                </div>
                <Button
                    btnName={'Set Price'}
                    classStyles={'nav__medium'}
                    handleClick={() => openModalMyMarketCardDetails(artData)}
                    cancelBg={undefined}
                />
                <Button
                    btnName={acceptOfferButtonText(artData.highestBid ?? '-', artData.highestOffer ?? '-')}
                    classStyles={'nav__medium long-button'}
                    handleClick={() => openModalMyMarketCardDetails(artData)}
                    disabled={!artData.highestBid && !artData.highestOffer}
                    cancelBg={undefined}
                />
            </div>
        </div>
    )
}

MyMarketCard.whyDidYouRender = true

export default MyMarketCard
